import api from '../api/api'


// initial state
const state = {
  currency_name: 'RUB',
  currency_id: '',
  course: 1,
  state: 'default',
};

// getters
// noinspection JSUnusedGlobalSymbols
const getters = {
};

// actions
// noinspection JSUnusedGlobalSymbols
const actions = {
  getCourse({dispatch, commit}, payload) {
    console.log('ACTION - getCourse :', payload);
    commit('setState', 'loading');
    return api.getCourse(payload, data => {
      commit('setCourse', data.data);
      commit('setState', 'stored');
    })
  },
};

// mutations
// noinspection JSUnusedGlobalSymbols
const mutations = {
  setCourse (state, data) {
    state.course = data.course;
    state.currency_name = data.currency_name;
    state.currency_id = data.currency_id;
  },

  setState (state, list_status) {
    state.state = list_status;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
